export const isEmailValid = (emailToSend: string | undefined) =>
    !!emailToSend && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailToSend);
